/**
 * Action Name: md_header_filter
 */

export function filterHeader() {
	var $trigger = jQuery('#trigger-filter');

	var $brand = jQuery('#jx-select-brand');
	var $reg = jQuery('#jx-select-reg');
	var $price = jQuery('#jx-select-price');
	var $model = jQuery('#jx-select-model');

	jQuery('body').on('change', '#jx-select-brand', function () {
		var data = {
			'action': 'md_header_filter',
			'security': md_object.nonce,
			'brand': $brand.val(),
			'reg': $reg.val(),
			'price': $price.val()
		};

		jQuery.post(md_object.ajaxurl, data, (response) => {
			jQuery('#jx-car-count').html(response);
		});
	});

	jQuery('body').on('change', '#jx-select-reg', function () {
		var data = {
			'action': 'md_header_filter',
			'security': md_object.nonce,
			'brand': $brand.val(),
			'reg': $reg.val(),
			'price': $price.val()
		};

		jQuery.post(md_object.ajaxurl, data, function (response) {
			jQuery('#jx-car-count').html(response);
		});
	});

	jQuery('body').on('change', '#jx-select-price', function () {
		var data = {
			'action': 'md_header_filter',
			'security': md_object.nonce,
			'brand': $brand.val(),
			'reg': $reg.val(),
			'price': $price.val()
		};
		jQuery.post(md_object.ajaxurl, data, function (response) {
			jQuery('#jx-car-count').html(response);
		});
	});

	$trigger.click(function (e) {
		jQuery(this).attr('href', function (i, href) {
			return href + '?brand=' + $brand.val() +'&model=' + $model.val() + '&price=' + $price.val() + '&reg=' + $reg.val();
		});
	});
}

/**
 * Action Name: md_archive_filter
 */

export function filterArchive() {
	const params = new URLSearchParams(location.search);
	var hasFilter = jQuery('.pb__car--detail-filter').length;
	console.log(hasFilter);

	if (params.has('brand') && hasFilter) {
		var brand = params.get('brand');
		jQuery('#jx-select-brand-detail').val(brand).trigger("change");
	}

	if (params.has('price') && hasFilter) {
		var price = params.get('price');
		jQuery('#jx-select-price-detail').val(price).trigger("change");
	}

	if (params.has('reg') && hasFilter) {
		var reg = params.get('reg');
		jQuery('#jx-select-reg-detail').val(reg).trigger("change");
	}

	if (jQuery('.pb__car--detail-filter').length) {
		console.log('Brand: ' + brand + ' | Price: ' + price + ' | Reg: ' + reg);
	}

	jQuery('body').on('change', '#jx-detail-filter-form', function () {
		console.log('filtered');
		var $brand = jQuery('#jx-select-brand-detail').val();
		var $price_min = jQuery('#jx-select-price-min-detail').val();
		var $price_max = jQuery('#jx-select-price-max-detail').val();
		var $reg_min = jQuery('#jx-select-reg-min-detail').val();
		var $reg_max = jQuery('#jx-select-reg-max-detail').val();
		var $type = jQuery('#jx-select-type-detail').val();
		var $model = jQuery('#jx-select-model-detail').val();
		var $kilometer_min = jQuery('#jx-select-kilometer-min-detail').val();
		var $kilometer_max = jQuery('#jx-select-kilometer-max-detail').val();
		var $fuel = jQuery('#jx-select-fuel-detail').val();
		var $drive = jQuery('#jx-select-drive-detail').val();

		if ($brand === 'all') {
			$model = 'all'
		}

		var data = {
			'action': 'md_archive_filter',
			'brand': $brand,
			'model': $model,
			'price_min': $price_min,
			'price_max': $price_max,
			'kilometer_min': $kilometer_min,
			'kilometer_max': $kilometer_max,
			'reg_min': $reg_min,
			'reg_max': $reg_max,
			'type': $type,
			'fuel': $fuel,
			'drive': $drive
		};

		jQuery.post(md_object.ajaxurl, data, function (response) {
			if (response == 0) {
				console.log('empty');
				jQuery('#test-result').html(response);
				jQuery('#test-result').append('<p>Keine Einträge für Ihre Suche gefunden, bitte ändern Sie ihre Sucheinstellungen.</p>');
			} else {
				jQuery('#test-result').html(response);
			}
		});
	});
}

export default { filterArchive, filterHeader };
